export default "__VITE_ASSET__BzWVn8aN__"